import React from "react";
import Page from "../components/Page";

const Careers = () => <Page title="Careers Us">this is the Careers</Page>;

export default Careers;
